export default __webpack_public_path__ + "static/logo_w-abe384533213933c0d0d3d28240b48b5.png";